// Set initial value for the debounce function.
window.debounceTimeoutId = null;

// Toggle functionality. Default.
jQueryCaw('.list-make-visible-toggle').click(function (event) {
    jQueryCaw(this).toggleClass('active');
    jQueryCaw(this).parent().parent().find('.is-hidden, .is-visible').toggleClass('is-hidden is-visible');
    event.preventDefault();
});

// Toggle functionality. Description.
jQueryCaw('.description-make-visible-toggle').click(function (event) {
    jQueryCaw(this).toggleClass('active');
    jQueryCaw(this).parent().parent().find('.is-hidden, .is-visible').toggleClass('is-hidden is-visible');
    jQueryCaw(this).parent().parent().find('.is-teaser, .is-full').toggleClass('is-teaser is-full');
    event.preventDefault();
});

window.addEventListener('resize', function () {
    const $contentElem = jQueryCaw('.caw-foldout__content .description');

    $contentElem.each(function () {
        const $toggleElem = jQueryCaw(this).next('.description__toggle');
        let totalHeight = 0;

        jQueryCaw(this).children().each(function () {
            totalHeight = totalHeight + jQueryCaw(this).outerHeight(true);
        });

        if (jQueryCaw(this).outerHeight() >= totalHeight) {
            $toggleElem.addClass('hidden');
        } else {
            $toggleElem.removeClass('hidden');
        }
    });
});

window.addEventListener("DOMContentLoaded", () => {
    let gaCookieId = getCookie('_ga');
    const tracking_id_av_value = [];
    const tracking_field = document.getElementById("offer_tracking_id");

    // Get the UnameIT object visitor id.
    if (typeof UnameIT === 'object') {
        const tracking_id = UnameIT.getVisitorId();
        if (tracking_field && tracking_id) {
            tracking_id_av_value.push({
                'name': 'RelatieSiteTrackID',
                'value': tracking_id
            });
        }
    }

    // Get the GA / Client ID.
    if (tracking_field && gaCookieId) {
        const match = gaCookieId.match(/^GA\d+\.\d+\.(\d+\.\d+)$/);
        if (match) {
            tracking_id_av_value.push({
                'name': 'ClientID',
                'value': match[1]
            });
        }
    }

    if (tracking_id_av_value.length > 0) {
        tracking_field.value = JSON.stringify(tracking_id_av_value);
    }
});


// Detail navigation, trigger smooth scroll.
jQueryCaw('.caw-detail-nav a[href*=\\#]').click(function () {
    jQueryCaw(this).trigger('hashchange');
});

// Page load / hash change, trigger smooth scroll.
jQueryCaw(window).on('load hashchange', function () {
    if (window.location.hash) {
        let hashValue = window.location.hash.substring(1);
        let element = document.getElementById(hashValue);
        if (element) {
            smoothScrollingTo($(element));
        }
    }
});

jQueryCaw(document).ready(function () {
    const overviewUrl = sessionStorage.getItem("caw4_overview_url");

    if (overviewUrl != null && overviewUrl !== '') {
        jQueryCaw('#app-wrapper .link--back--detail').attr('href', overviewUrl);
    }

    jQueryCaw(".warranty-modal").on("hidden.bs.modal", function () {
        jQueryCaw('#app-wrapper.caw').removeClass('modal--open');
        jQueryCaw('#caw-container.caw').removeClass('modal--open');
    });

    jQueryCaw(".warranty-link").on("click", function () {
        jQueryCaw('#app-wrapper.caw').addClass('modal--open');
        jQueryCaw('#caw-container.caw').addClass('modal--open');
    });
});

// Smooth scroll functionality.
function smoothScrollingTo(targetElem)
{
    var parentElem = jQueryCaw('#caw-container');

    var parentOffset = parentElem.offset();
    var targetOffset = targetElem.offset();

    var scrollOffset = targetOffset.top - (parentOffset.top);

    jQueryCaw('html, body').animate({
        scrollTop: scrollOffset
    }, 500, 'linear');
}

// Form placeholders. Add placeholder attributes to form fields.
jQueryCaw('#caw-container form').find('input[type=text], input[type=email], input[type=password], input[type=tel]').each(function () {
    if (!jQueryCaw(this).attr('placeholder')) {
        jQueryCaw(this).attr('placeholder', ' ');
    }
});

function getCookie(cname)
{
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function cawMobileMenuBtns()
{
    if (jQueryCaw('#caw-container').find('#mobile-menu') && jQueryCaw('#caw-container #mobile-menu .caw-mobilemenu').is(':visible')) {
        jQueryCaw('html, body').addClass('caw--mobile--buttons');
    } else {
        jQueryCaw('html, body').removeClass('caw--mobile--buttons');
    }
}

cawMobileMenuBtns();
jQueryCaw(window).on('resize', function () {
    cawMobileMenuBtns();
});

// Overlay for spinners that can be toggled.
toggleIframeOverlay(jQueryCaw('.spinner.spinner--toggle'));

function toggleIframeOverlay($elem)
{
    const activeClass = 'active';
    const scrollClass = 'scrollIntoView';

    $elem.find('.pmb--close').on('click', function (ev) {
        ev.stopPropagation();

        jQueryCaw(document).trigger('click');

        const offsetTop = (typeof stickyEl != 'undefined') ? jQueryCaw(stickyEl).outerHeight() : 0;

        jQueryCaw('html, body').animate({
            scrollTop: (jQueryCaw('.caw-detail.container').offset().top - offsetTop)
        }, 500, 'linear');
    });

    $elem.on('click', function (ev) {
        ev.stopPropagation();

        if (isVisible() && !jQueryCaw(this).hasClass(activeClass)) {
            jQueryCaw(this).addClass(activeClass);
            jQueryCaw(this).addClass(scrollClass);

            const clickedElem = jQueryCaw(this);
            const offsetTop = (typeof stickyEl != 'undefined') ? jQueryCaw(stickyEl).outerHeight() : 0;

            jQueryCaw('html, body').animate({
                scrollTop: (clickedElem.offset().top - offsetTop)
            }, 500, 'linear', function () {
                jQueryCaw(clickedElem).removeClass(scrollClass);
            });
        }
    });

    jQueryCaw(document).on('click', function (ev) {
        if (!$elem.is(ev.target) && $elem.has(ev.target).length === 0) {
            $elem.removeClass(activeClass);
        }
    });

    jQueryCaw(document).scroll(function () {
        if ($elem.hasClass(activeClass) && !$elem.hasClass(scrollClass)) {
            const offsetTop = (typeof stickyEl != 'undefined') ? jQueryCaw(stickyEl).outerHeight() : 0;
            const scrollTop = jQueryCaw(window).scrollTop();

            if (scrollTop > (($elem.offset().top - offsetTop) + ($elem.height() / 4))) {
                $elem.removeClass(activeClass);
            }
        }
    });

    function isVisible()
    {
        if ($elem.find('.pmb--open').is(':visible') || $elem.find('.pmb--close').is(':visible')) {
            return true;
        }
    }
}

// Form submit event, block multiple submit actions.
let forms = document.querySelectorAll('form.prevent-multiple-submit');
for (let form of forms) {
    form.addEventListener('submit', function (e) {
        let target = e.target;
        let buttons = target.querySelectorAll('[type="submit"]');
        e.preventDefault();
        for (let button of buttons) {
            debounce(() => form.submit(), 250);
        }
    });
}

/**
 * Adds two buttons.
 *
 * 360 toggle button:
 * Sets a cookie for the 360 toggle and reloads the page.
 *
 * 360 close button:
 * Removes the cookie and reloads the page.
 */
const enableThreeSixtyToggles = function () {
    const ThreeSixtyToggles = document.querySelectorAll('.unameit-threesixty-toggle');
    const ThreeSixtyClose = document.querySelector('.unameit-threesixty-close');
    for (let i = 0; i < ThreeSixtyToggles.length; i++) {
        ThreeSixtyToggles[i].addEventListener('click', function (event) {
            event.preventDefault();
            document.cookie = 'caw4_360_toggle=1; path=/;';
            location.reload();
        });
    }

    if (ThreeSixtyClose) {
        ThreeSixtyClose.addEventListener('click', function (event) {
            event.preventDefault();
            document.cookie = 'caw4_360_toggle=0; path=/;';
            location.reload();
        });
    }
}

/**
 * When the cookie for 360 toggle has been detected load this script.
 *
 * The script will hide all other buttons, they do not work anyway. It shows the 360 close button (see above).
 * And it will remove the cookie in case a user goes to the overview and opens a new vehicle detail page.
 */
const alterThreeSixtyToggles = function () {
    const container = document.getElementById('cawDetailHeaderContainer');
    const template = document.getElementById('caw-360-template');
    container.insertBefore(template.content, container.firstChild);
    document.getElementById('cawDetailGalleryContainer').classList.add('is-hidden');
    document.cookie = 'caw4_360_toggle=0; path=/;';
    let items = document.querySelectorAll('.media-toggle');
    items.forEach((item) => item.classList.add('is-hidden'));
    document.querySelector('.unameit-threesixty-close').classList.remove('is-hidden');
}

const debounce = (callback, wait) =>  {
    window.clearTimeout(window.debounceTimeoutId);
    window.debounceTimeoutId = window.setTimeout(() => callback(), wait);
};

/**
 * Look for the UTM Tracking input type, prefill it with cookie values.
 */
const utm_tracking_input = document.querySelector('input[data-id="utm_tracking"]');
if (utm_tracking_input) {
    const utm_object = {};
    const utm_campaign = getCookie('utm_campaign');
    const utm_medium = getCookie('utm_medium');
    const utm_source = getCookie('utm_source');

    if (utm_source) {
        utm_object.utm_source = utm_source;
    }
    if (utm_campaign) {
        utm_object.utm_campaign = utm_campaign;
    }
    if (utm_medium) {
        utm_object.utm_medium = utm_medium;
    }
    utm_tracking_input.value = JSON.stringify(utm_object);
}
